

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn span").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    
});

$(document).ready(function() {
var owl = $('.homebanner .owl-carousel');
  owl.owlCarousel({
    dots: false,
    //navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
    autoplay: true,
    nav: false,
    dotsEach: false,
    autoplayTimeout: 3000,
	  animateOut: 'fadeOut',
	  animateIn: 'fadeIn',
	  smartSpeed: 1000,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      1400: {
        items: 1
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.slide_main.owl-carousel');
  owl.owlCarousel({
    dots: false,
    navText : ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: false,
    stagePadding: 0,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      1200: {	
        items: 1
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.twocarocel.owl-carousel');
  owl.owlCarousel({
    dots: true,
    margin:20,
    navText : ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: true,
    loop: true,
    responsive: {
      0: {	
        items: 1,
        margin:10,
      },
      481: {	
        items: 1,
        margin:10,
      },
      576: {	
        items: 1
      },
      1200: {
        items: 2
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.threecarocel.owl-carousel');
  owl.owlCarousel({
    dots: true,
    margin:20,
    navText : ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: true,
    loop: true,
    responsive: {
      0: {	
        items: 1,
        margin:10,
      },
      481: {	
        items: 1,
        margin:10,
      },
      576: {	
        items: 2
      },
      1200: {
        items: 3
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.fivecarocel.owl-carousel');
  owl.owlCarousel({
    dots: true,
    margin:20,
    navText : ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: true,
    loop: true,
    responsive: {
      0: {	
        items: 1,
        margin:10,
      },
      481: {	
        items: 3,
        margin:10,
      },
      576: {	
        items: 3
      },
      1200: {
        items: 5
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.testecaro.owl-carousel');
  owl.owlCarousel({
    dots: false,
    navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      481: {	
        items: 1
      },
      576: {	
        items: 2
      },
      1200: {
        items: 2
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.candidates_slide.owl-carousel');
  owl.owlCarousel({
    loop: true,
      margin: 0,
      navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 0,
      smartSpeed: 3000,
      fluidSpeed: true,
      autoplayTimeout:3000,
      autoplayHoverPause:false,
      responsiveClass: true,
      nav: false,
      dots: false,
    responsive: {
      0: {	
        items: 2
      },
      360: {	
        items: 3
      },
      481: {	
        items: 4
      },
      576: {	
        items: 5
      },
      1200: {
        items: 6
      }
    }
  });
});

$(document).ready(function() {
  var owl = $('.trangCaro.owl-carousel');

  owl.owlCarousel({
    dots: false,
    margin: 20,
    navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true, // Ensure it doesn't loop
    responsive: {
      0: { items: 1 },
      481: { items: 1 },
      576: { items: 2 },
      900: { items: 2, margin: 20 },
      1200: { items: 3, margin: 25 }
    },
    onInitialized: function(event) {
      checkNavButtons(event);
    },
    onChanged: function(event) {
      checkNavButtons(event);
    }
  });

  function checkNavButtons(event) {
    var itemCount = event.item.count; // Total number of items
    var currentIndex = event.item.index; // Current index
    var visibleItems = event.page.size; // Number of visible items at once
    var lastIndex = itemCount - visibleItems; // Last possible index before the end

    if (currentIndex === 0) {
      $('.owl-prev').prop('disabled', true); // Disable prev on first item
    } else {
      $('.owl-prev').prop('disabled', false);
    }

    if (currentIndex >= lastIndex) {
      $('.owl-next').prop('disabled', true); // Disable next on last item
    } else {
      $('.owl-next').prop('disabled', false);
    }
  }
});


$('.textarea-editor').summernote({
    placeholder: '',
        tabsize: 2,
        height: 120,
    cleaner: {
        notTime: 2400,
        action: 'both',
        newline: '<br>',
        notStyle: 'position:absolute;bottom:0;left:2px',
        icon: '<i class="note-icon">[Your Button]</i>'
    },
    toolbar: [
          // ['style', ['style']],
          ['font', ['bold', 'underline', 'clear']],
          // ['color', ['color']],
          ['para', ['ul', 'ol', 'link', ['linkDialogShow', 'unlink']]]
          // ['para', ['ul', 'ol', 'paragraph']]
          // ['table', ['table']],
          // ['insert', ['link', 'picture', 'video']],
          // ['view', ['fullscreen', 'codeview', 'help']]
    ]
});












